import { connector } from "../common/connector"

export const getItems = (params) => {
    return connector.get('api/usuarios', {params});
}